import HttpService from 'src/core/services/http.service';
import { CommandResult } from 'src/core/stores/types';
import queryString from 'query-string';
import { Container } from 'inversify';
import { EMPTY_GUID, PermissionsConstants } from './types';

export default class PermissionService {
  private baseUrl: string;
  private httpService: HttpService;

  private currentUser: { userId: string; tenantId: string };

  constructor(baseUrl: string, container: Container) {
    this.baseUrl = `${baseUrl}/identity/api/permissions`;
    this.httpService = container.get(HttpService);

    this.setCurrentUser.bind(this);
    this.check.bind(this);
    this.checkForCurrentUser.bind(this);
    this.filter.bind(this);
    this.filterForCurrentUser.bind(this);
    this.filterScopes.bind(this);
    this.filterScopesForCurrentUser.bind(this);

    this.currentUser = { userId: EMPTY_GUID, tenantId: EMPTY_GUID };
  }

  public setCurrentUser(userId: string, tenantId: string) {
    this.currentUser = { userId, tenantId };
  }

  public clearCurrentUser() {
    this.currentUser = { userId: EMPTY_GUID, tenantId: EMPTY_GUID };
  }

  public async check(userId: string, scopeId: string, permission: string | PermissionsConstants): Promise<boolean> {
    const qs = { identityId: userId, identityType: 'User', scopeId, permission };

    try {
      const result = await this.httpService.get<CommandResult<any>>(`${this.baseUrl}/check?${queryString.stringify(qs)}`);
      return result?.data?.isSuccess ?? false;
    } catch {
      return false;
    }
  }
  public async checkInMainOrg(userId: string, permission: string | PermissionsConstants): Promise<boolean> {
    const qs = { identityId: userId, identityType: 'User', permission };

    try {
      const result = await this.httpService.get<CommandResult<any>>(`${this.baseUrl}/check-in-main-org?${queryString.stringify(qs)}`);
      return result?.data?.isSuccess ?? false;
    } catch {
      return false;
    }
  }
  public checkForCurrentUser(scopeId: string, permission: string | PermissionsConstants): Promise<boolean> {
    return this.check(this.currentUser.userId, scopeId, permission);
  }

  public checkForCurrentUserInTenant(permission: string | PermissionsConstants): Promise<boolean> {
    return this.checkForCurrentUser(this.currentUser.tenantId, permission);
  }

  public async filter(userId: string, scopeId: string, permissions: (string | PermissionsConstants)[]): Promise<string[]> {
    const body = { identityId: userId, identityType: 'User', scopeId, permissions };

    try {
      const result = await this.httpService.post<any, CommandResult<string[]>>(`${this.baseUrl}/filter`, body);
      return result?.data.item ?? [];
    } catch {
      return [];
    }
  }

  public filterForCurrentUser(scopeId: string, permissions: (string | PermissionsConstants)[]): Promise<string[]> {
    return this.filter(this.currentUser.userId, scopeId, permissions);
  }

  public filterForCurrentUserInTenant(permissions: (string | PermissionsConstants)[]): Promise<string[]> {
    return this.filterForCurrentUser(this.currentUser.tenantId, permissions);
  }

  public async filterScopes(userId: string, scopesId: (string | PermissionsConstants)[], permission: string): Promise<string[]> {
    const body = { identityId: userId, identityType: 'User', scopesId, permission };

    try {
      const result = await this.httpService.post<any, CommandResult<string[]>>(`${this.baseUrl}/filter-Scopes`, body);
      return result?.data.item ?? [];
    } catch {
      return [];
    }
  }

  public filterScopesForCurrentUser(scopesId: string[], permission: string | PermissionsConstants): Promise<string[]> {
    return this.filterScopes(this.currentUser.userId, scopesId, permission);
  }
}
